"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("./StoreTile.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var StoreTile = function StoreTile(_ref) {
  var store = _ref.store,
    handleClick = _ref.handleClick,
    successLabel = _ref.successLabel,
    loginType = _ref.loginType,
    errorIcon = _ref.errorIcon,
    optmizeIcon = _ref.optmizeIcon,
    infoIcon = _ref.infoIcon,
    everythingOkIcon = _ref.everythingOkIcon,
    key = _ref.key,
    isDisableIcon = _ref.isDisableIcon,
    isDisableText = _ref.isDisableText,
    arrowIcon = _ref.arrowIcon;
  return /*#__PURE__*/_react.default.createElement("div", {
    key: key,
    className: "storeTile-wrapper",
    "data-testid": "parentWrapper",
    onClick: function onClick() {
      return handleClick(store);
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "storeTile-infor"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "storeTile-name",
    "data-testid": "storeTile-name"
  }, store.name), store.Organization && loginType === "dispatcher" && /*#__PURE__*/_react.default.createElement("p", {
    className: "owner-para",
    "data-testid": "storeTile-isOrganization"
  }, store.Organization.name), /*#__PURE__*/_react.default.createElement("div", {
    className: "storeTile-address",
    "data-testid": "storeTile-address"
  }, /*#__PURE__*/_react.default.createElement("p", null, store.address)), /*#__PURE__*/_react.default.createElement("div", {
    className: "storeTile-iconwrapper"
  }, store.isActive === true ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, store.error && /*#__PURE__*/_react.default.createElement("div", {
    className: "errorIcon-div",
    "data-testid": "erroricon-div"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: errorIcon,
    alt: ""
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "errorNumber",
    "data-testid": "storeTile-error"
  }, store.error)), store.optimize && /*#__PURE__*/_react.default.createElement("div", {
    className: "optimizeIcon-div",
    "data-testid": "optimizeIcon-div"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: optmizeIcon,
    alt: ""
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "optmizeNumber",
    "data-testid": "storeTile-optimize"
  }, store.optimize)), store.info && /*#__PURE__*/_react.default.createElement("div", {
    className: "infoIcon-div",
    "data-testid": "infoIcon-div"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: infoIcon,
    alt: ""
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "infoNumber",
    "data-testid": "storeTile-info"
  }, store.info)), !store.error && !store.info && !store.optimize && /*#__PURE__*/_react.default.createElement("div", {
    className: "everythingOkIcon-div",
    "data-testid": "everythingok-div"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: everythingOkIcon
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "everythingOk",
    "data-testid": "everythingOK"
  }, successLabel))) : /*#__PURE__*/_react.default.createElement("div", {
    className: "isDisable-div"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "isDisable-icon"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: isDisableIcon
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: "isDisable-text"
  }, isDisableText)))), /*#__PURE__*/_react.default.createElement("div", {
    className: "storeTile-navigateIcon"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: arrowIcon,
    alt: ""
  })));
};
var _default = StoreTile;
exports.default = _default;